<template>
  <v-dialog v-model="dialog" persistent retain-focus max-width="350" content-class="rtls-dialog">
    <template #activator="{ props: activatorProps }">
      <v-tooltip location="bottom">
        <template #activator="{ props: tooltipActivatorProps }">
          <v-btn
            v-bind="{ ...activatorProps, ...tooltipActivatorProps }"
            icon
            variant="text"
            :disabled="disabled"
            :loading="loading"
          >
            <v-icon size="30"> $trash </v-icon>
          </v-btn>
        </template>
        <span>{{ t('actions.delete') }}</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-card-title class="text-h6 align-self-end" primary-title>
        <v-btn class="close-button" icon variant="text" @click="closeModal">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="text-h6 text-center py-0">
        <p>{{ tkey('question', { extractName }) }}</p>
        <strong>{{ tkey('warning') }}</strong>
      </v-card-text>

      <v-card-actions class="justify-center flex-column">
        <v-btn primary class="btn-delete ma-2" @click="_deleteExtract">
          {{ tkey('action') }}
        </v-btn>
        <v-hover disabled>
          <v-btn variant="text" class="cancel ma-2" @click="closeModal">
            {{ t('actions.cancel') }}
          </v-btn>
        </v-hover>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { get } from 'lodash';
import { mapState, mapActions } from 'pinia';
import { useCompoundExtractStore } from '@/stores/compound-extract';
import { useExtractsStore } from '@/stores/extracts';
import { usePermission } from '@/composables/use-permission';
import { useInternationalization } from '@/composables/use-internationalization';

export default {
  setup() {
    const { canDeleteCompoundsExtract } = usePermission();
    const { tkey, t } = useInternationalization('compoundExtractsPage.deleteButton');

    return {
      canDeleteCompoundsExtract,
      t,
      tkey,
    };
  },

  data() {
    return {
      dialog: false,
      loading: false,
    };
  },

  computed: {
    ...mapState(useCompoundExtractStore, ['getExtractById']),

    extractId() {
      return get(this.params, 'extractId');
    },

    extract() {
      return this.getExtractById(this.extractId) || {};
    },

    extractName() {
      return get(this.params, 'filenameOnDownload');
    },

    disabled() {
      return (
        !this.canDeleteCompoundsExtract || !this.extract._id || !this.extract.extractSettingsId
      );
    },
  },

  methods: {
    ...mapActions(useExtractsStore, ['deleteExtract']),

    async _deleteExtract() {
      this.loading = true;
      try {
        this.closeModal();
        await this.deleteExtract(this.extractId);
      } finally {
        this.loading = false;
        this.params.refresh();
      }
    },

    closeModal() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
